<template>
  <div>
    <div class="user-notifications-wrapper" ref="bellWrapper">
      <img @click.stop="showNotifications()" src="/img/svg/common/bell.svg" alt="">
      <span class="notification-badge" v-if="countNew > 0">{{ countNew }}</span>
      <span class="notification-badge nb-total" v-if="countNew === 0 && count > 0">{{ count }}</span>
    </div>
  </div>
</template>

<script>
import ClientNotifications from "./notifications.vue"
import BaseAdminMixin from "../../../../admin/components/mixins/BaseAdminMixin.vue";

export default {
  name: 'bell',
  components: {ClientNotifications},
  mixins: [
    BaseAdminMixin
  ],
  data() {
    return {
      countNew: 0,
      count: 0,
      clickOutsideListener: null
    }
  },
  mounted() {
    setInterval(async () => {
      await this.getCountNewNotifications();
    }, 60000);

    this.getCountNewNotifications();
  },
  beforeDestroy() {
    this.removeClickListener();
  },
  methods: {
    async getCountNewNotifications() {
      let response = await this.sendRequest('cabinet/client/notification/getCountNewNotifications', 'get');
      this.countNew = response.counts.countNew;
      this.count = response.counts.count;
    },
    showNotifications() {
      const clientNotifications = document.querySelector('.notification-container');
      const styleSelected = clientNotifications.style.display;
      const display = styleSelected === 'block' ? 'none' : 'block';
      clientNotifications.style.display = display;

      clientNotifications.dispatchEvent(new CustomEvent('displayChanged', {detail: display}));

      if (this.countNew > 0) {
        this.resetNewNotifications();
      }

      this.removeClickListener();

      if (display === 'block') {
        this.clickOutsideListener = (event) => {
          const bellWrapper = this.$refs.bellWrapper;
          const notificationsContainer = document.querySelector('.notification-container');

          if (!bellWrapper.contains(event.target) &&
              !notificationsContainer.contains(event.target)) {
            notificationsContainer.style.display = 'none';
            notificationsContainer.dispatchEvent(new CustomEvent('displayChanged', {detail: 'none'}));
            this.removeClickListener();
          }
        };

        document.addEventListener('click', this.clickOutsideListener);
      }
    },
    removeClickListener() {
      if (this.clickOutsideListener) {
        document.removeEventListener('click', this.clickOutsideListener);
        this.clickOutsideListener = null;
      }
    },
    async resetNewNotifications() {
      await this.sendRequest('cabinet/client/notification/resetNewNotifications', 'post');
      this.countNew = 0;
    },
  }
}
</script>

<style scoped lang="scss">
.user-notifications-wrapper {
  display: flex;
  align-items: center;
  margin-right: 10px;
  position: relative;

  img {
    margin: 8px 2px 0 0;
    height: 25px;
    width: 22px;

    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }

  .notification-badge {
    position: absolute;
    right: 17px;
    top: 1px;
    background: #EF8512;
    color: white;
    border-radius: 50%;
    min-width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 400;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 0 4px;
  }

  .notification-badge.nb-total {
    background: #5a5653;
  }
}
</style>